import DG from '2gis-maps';

export default function (element, data) {
    DG.then(function() {
        var map = DG.map(element, {
            'center': [43.231392, 76.94543],
            'zoom': 18,
            'scrollWheelZoom': false,
        });

        // Создаем группу для всех маркеров
        const markers = DG.featureGroup();

        // Проходим по каждому филиалу в данных
        for (const branch of data.branches) {
            // Преобразуем строку с координатами в массив чисел с плавающей точкой
            const coords = branch.coords.split(",").map((v) => parseFloat(v.trim()));

            // Создаем маркер с кастомной иконкой и привязываем к нему всплывающее окно
            DG.marker(coords, {
                icon: DG.icon({
                    iconUrl: '/images/map_marker.svg',
                    iconSize: [30, 36], // (ширина, высота)
                    iconAnchor: [15, 25], // Точка привязки иконки (центр основания)
                })
            }).addTo(markers).bindPopup(branch.description);
        }

        // Добавляем группу маркеров на карту
        markers.addTo(map);

        // Устанавливаем границы карты, чтобы они соответствовали всем маркерам
        map.fitBounds(markers.getBounds(), {
            maxZoom: 18 // Максимальный уровень зума при подгонке границ
        });

        // Переменные для хранения предыдущего положения и зума карты
        let oldLatLng = null;
        let oldZoom = null;

        // Обработчик события открытия всплывающего окна
        markers.on('popupopen', function(e) {
            oldLatLng = map.getCenter(); // Сохраняем текущее положение центра карты
            oldZoom = map.getZoom(); // Сохраняем текущий уровень зума
            map.setView(e.popup._latlng, 17); // Устанавливаем вид на открытое всплывающее окно с определенным зумом
        });

        // Обработчик события закрытия всплывающего окна
        markers.on('popupclose', function(e) {
            map.setView(oldLatLng, oldZoom); // Возвращаемся к предыдущему положению и зуму
        });

        // Устанавливаем вид на центр карты и корректируем зум, если он превышает заданный
        map.setView(map.getCenter(), Math.min(map.getZoom(), 14));
    });
}
